// Drag snapping for the house floor-plan editor (Stage 14b.2).
//
// When a vertex is dragged in edit mode we snap it onto the X and/or Y of
// another existing vertex (within tolerance). Two effects fall out of the same
// rule:
//   • snapping the dragged vertex's X onto a NEIGHBOUR's X makes the wall
//     between them exactly vertical (angle-snap to 0/90°); likewise Y →
//     horizontal;
//   • snapping onto a NON-neighbour's X/Y lines the corner up into the same
//     column / row (alignment guide).
//
// Pure JS, no DOM, no Konva — unit-tested with Vitest.

// Snap a dragged vertex's position onto the nearest other vertex's X and Y
// (each axis independently) within `tolM` metres. Returns the (possibly)
// snapped coordinates plus the guide coordinates that were hit, so the caller
// can draw alignment guide lines:
//   { xM, yM, guideX, guideY }
// guideX / guideY are null when that axis did not snap.
export function snapDraggedVertex(graph, vertexId, xM, yM, tolM) {
  let snX = xM, snY = yM
  let bestDX = tolM, bestDY = tolM
  let guideX = null, guideY = null
  for (const v of graph.vertices) {
    if (v.id === vertexId) continue
    const dx = Math.abs(v.xM - xM)
    if (dx < bestDX) { bestDX = dx; snX = v.xM; guideX = v.xM }
    const dy = Math.abs(v.yM - yM)
    if (dy < bestDY) { bestDY = dy; snY = v.yM; guideY = v.yM }
  }
  return { xM: snX, yM: snY, guideX, guideY }
}
